import axios from 'axios';

export default {
    create(context, data) {
        var options = {
            url: window.apiUrl + '/intro-video',
            method: 'POST',
            data:data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    delete(context, id) {
        var options = {
            url: window.apiUrl + '/intro-video/' + id,
            method: 'DELETE',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },    
    get(context, term, week) {
        var url = window.apiUrl + '/intro-videos';

        if (term) {
            url += '?term=' + term
        }

        try {
            if (week || week.toString() == '0') {
                url += '&week=' + week
            }
        }
        catch(e){
           
        }

      var options = {
            url: url,
            // params: {
            //     cache: 'introvideos'
            // },
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });  
    },   

};



// WEBPACK FOOTER //
// ./src/services/intro-videos/index.js